export default "__VITE_ASSET__h0WHkBC___"